import React from 'react';
import { ISigningAppointmentDocumentResponse } from 'types/signingAppointment/ISigningAppointmentDocumentResponse';
import { Show } from '../../../../../../shared/Show';
import { AssociateDocumentButton } from './AssociateDocumentButton';
import { OutgoingItem } from './OutgoingItem';
import { SendDocumentsButton } from './SendDocumentsButton';
import { CardTW } from '../../../../../../../tailwindComponents/CardTW/CardTW';

export interface OutgoingDocumentsTableProps {
  outgoingDocs: ISigningAppointmentDocumentResponse[];
  setPreviewDoc: (docUrl: string) => void;
}

export const OutgoingDocumentsTable: React.FC<OutgoingDocumentsTableProps> = ({ outgoingDocs, setPreviewDoc }) => {
  return (
    <CardTW>
      <section className="pt-4" data-test-id={`outgoing-documents-title`}>
        <span className="font-inter text-base font-semibold not-italic leading-6 text-black">Outgoing Documents</span>
        <Show when={!!outgoingDocs.length} fallback={<div>No Outgoing documents</div>}>
          <div className="space-y-4">
            {outgoingDocs.map((document) => (
              <OutgoingItem key={document.id} document={document} setPreviewDoc={setPreviewDoc} />
            ))}
          </div>
        </Show>

        <section className="flex justify-between pt-4" data-test-id="outgoing-documents-footer">
          <AssociateDocumentButton />
          <SendDocumentsButton outgoingDocs={outgoingDocs} />
        </section>
      </section>
    </CardTW>
  );
};
